import { SELECIONAR_RESERVA_REEMBOLSO_SOLICITADO } from '../types'

export default function selecionaReservaReembolsoSolicitado (reservas) {
  return {
    type: SELECIONAR_RESERVA_REEMBOLSO_SOLICITADO,
    payload: reservas
  }
}